import React, { useContext } from 'react';
import { useAsync } from '@hooks';
import { fetchRealTimeSensorMonitoring } from '@api/monitoring';
import { SensorStatusDispatchContext, SensorStatusStateContext } from '../../../index';
import { setSensorList } from '../../../sensorStatusReducer';
import Bookmark from '../../../../Components/Bookmark';

const BookmarkIcon = ({ row: { original } }) => {
    const dispatch = useContext(SensorStatusDispatchContext);
    const { sensorListParam } = useContext(SensorStatusStateContext);
    const { promise: getRealTimeSensorMonitoring } = useAsync({
        promise: fetchRealTimeSensorMonitoring,
        resolve: res => {
            dispatch(setSensorList(res));
        },
        reject: err => console.error(err),
    });

    const handleRefresh = () => {
        getRealTimeSensorMonitoring({ ...sensorListParam });
    };

    return <Bookmark successCallback={handleRefresh} targetNum={original.targetNum} isBookmark={original.isBookmark} />;
};

export default BookmarkIcon;
